/*
Copyright 2025 TekNix Corporation

This software is proprietary and confidential to TekNix Corporation.
All rights reserved. No part of this software may be reproduced, distributed,
or transmitted in any form or by any means, including photocopying, recording,
or other electronic or mechanical methods, without the prior written permission
of TekNix Corporation, except in the case of brief quotations embodied in
critical reviews and certain other noncommercial uses permitted by copyright law.

For permission requests, write to TekNix Corporation at the address below:
TekNix Corporation
Legal Department

UNAUTHORIZED REPRODUCTION OR DISTRIBUTION IS STRICTLY PROHIBITED.
*/

export enum ReceiptType {
  Read = 'm.read',
  FullyRead = 'm.fully_read',
}

export const MAIN_ROOM_TIMELINE = 'main';

export type Receipt = {
  ts: number;
  thread_id?: string;
};

export type WrappedReceipt = {
  eventId: string;
  data: Receipt;
};

export type CachedReceipt = {
  type: ReceiptType;
  userId: string;
  data: Receipt;
};

export type ReceiptCache = Map<string, CachedReceipt[]>;

export type ReceiptContent = {
  [eventId: string]: {
    [key in ReceiptType | string]: {
      [userId: string]: Receipt;
    };
  };
};

// We will only hold a synthetic receipt if we do not have a real receipt or the synthetic is newer.
// map: receipt type → user Id → receipt
export type Receipts = Map<string, Map<string, [real: WrappedReceipt | null, synthetic: WrappedReceipt | null]>>;

export type CachedReceiptStructure = {
  eventId: string;
  receiptType: string | ReceiptType;
  userId: string;
  receipt: Receipt;
  synthetic: boolean;
};
